<header
    class="h-[60px] bg-white border-b border-slate-200 sticky top-0 z-50 px-5 flex items-center justify-between shadow-sm">

    <div class="flex items-center gap-5">

        <!-- LOGO -->
        <div class="flex items-center gap-2.5 pr-5 border-r border-slate-100">

            <img class="h-8"
                src="https://asset.cambodia.gov.kh/tourism/2023/11/web-logo.png">

            <div class="flex flex-col leading-tight">
                <span class="font-bold text-sm">ក្រសួងទេសចរណ៍</span>
                <span class="text-[10px] text-slate-500 uppercase">Admin Portal</span>
            </div>

        </div>

        <!-- DROPDOWN -->
        <div class="relative group">

            <button
                class="flex items-center gap-2 px-3.5 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 font-semibold text-sm">

                <span class="material-symbols-outlined text-[20px]">apps</span>
                <span>Admin Menu</span>
                <span class="material-symbols-outlined text-[20px]">expand_more</span>

            </button>

            <div
                class="absolute left-0 top-full mt-1.5 w-60 bg-white border border-slate-200 rounded-lg shadow-lg opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-all duration-200 py-1.5">

                <div *ngIf="isMenuLoading" class="px-3.5 py-2.5 text-slate-400 text-sm">
                    Loading menu...
                </div>

                <a *ngFor="let menu of adminMenus" [routerLink]="menu.route"
                    routerLinkActive="bg-blue-50 text-blue-700 border-l-4 border-blue-500 font-bold"
                    class="flex items-center gap-2.5 px-3.5 py-2.5 text-slate-600 text-sm hover:bg-slate-50">

                    <span class="material-symbols-outlined text-[20px]">{{ menu.icon }}</span>
                    <span>{{ menu.label }}</span>

                </a>

                <div *ngIf="!isMenuLoading && adminMenus.length === 0" class="px-3.5 py-2.5 text-slate-400 text-sm">
                    No menu available
                </div>

            </div>

        </div>


    </div>

    <!-- USER PROFILE -->
    <div class="relative group flex items-center gap-3">

        <!-- User Info -->
        <button class="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-slate-100 transition">

            <img src="https://i.pravatar.cc/40" class="w-8 h-8 rounded-full border object-cover">

            <div class="text-left leading-tight hidden md:block">
                <div class="text-sm font-semibold text-slate-700">
                    {{ username }}
                </div>
                <div class="text-xs text-slate-400">
                    {{ roleName }}
                </div>
            </div>

            <span class="material-symbols-outlined text-[20px] text-slate-500">
                expand_more
            </span>

        </button>

        <!-- Dropdown -->
        <div class="absolute right-0 top-full mt-2 w-44 bg-white border border-slate-200 rounded-lg shadow-lg
    opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-all duration-200">

            <a routerLink="/profile"
                class="flex items-center gap-2 px-3.5 py-2.5 text-sm text-slate-600 hover:bg-slate-50">

                <span class="material-symbols-outlined text-[18px]">person</span>
                Profile

            </a>

            <button (click)="logout()"
                class="w-full text-left flex items-center gap-2 px-3.5 py-2.5 text-sm text-red-600 hover:bg-red-50">

                <span class="material-symbols-outlined text-[18px]">logout</span>
                Logout

            </button>

        </div>

    </div>

</header>
